export default {
  destinations: [
    { destinationId: 'School',map: 'map1',bestTime: 0,medal: '',baseType: 'big-island' },
    { destinationId: 'Supermarket',map: 'map2',bestTime: 0,medal: '',baseType: 'big-island-concrete' },
    { destinationId: 'Shopping Mall',map: 'map3',bestTime: 0,medal: '',baseType: 'big-island-concrete' },
    { destinationId: 'Apartment Building',map: 'map4',bestTime: 0,medal: '',baseType: 'big-island-concrete' },
    { destinationId: 'Post Office',map: 'map5',bestTime: 0,medal: '',baseType: 'big-island-concrete' },
    { destinationId: 'Office Building',map: 'map6',bestTime: 0,medal: '',baseType: 'big-island-concrete' },
    { destinationId: 'House',map: 'map7',bestTime: 0,medal: '',baseType: 'big-island' },
    { destinationId: 'Park',map: 'map8',bestTime: 0,medal: '',baseType: 'big-island' },
    { destinationId: 'Fire Department',map: 'map9',bestTime: 0,medal: '',baseType: 'big-island-concrete' },
    { destinationId: 'Police Station',map: 'map10',bestTime: 0,medal: '',baseType: 'big-island-concrete' },
    { destinationId: 'Library',map: 'map11',bestTime: 0,medal: '',baseType: 'big-island' },
    { destinationId: 'Bank',map: 'map12',bestTime: 0,medal: '',baseType: 'big-island-concrete' }
  ]
};